<template>
  <ion-text class="text-md font-bold ion-text-brand">Warning</ion-text>
  <ion-text class="text-sm mb-1 block ion-text-purple my-6">Are you sure you want to permanently close your Jacaranda app account?</ion-text>
  <ion-text class="text-sm mb-1 block ion-text-purple my-6">By clicking on Yes, your account will be permanently closed and you wont be able to use your account again.</ion-text>
</template>